<template>
  <section>
    <v-toolbar class="box-shadow">
      <v-btn class="mr-3 box-shadow" color="primary" @click="$router.back()">Back</v-btn>
      <v-text-field hide-details outlined clearable placeholder="Search" dense v-model="table_data.search"/>
    </v-toolbar>


    <v-container fluid>
      <v-card>
        <v-data-table :headers="table_data.headers"
                      :items="table_data.items"
                      :search="table_data.search">
          <template v-slot:item.practice_areas="{ value }">
            <div v-for="(item, idx) in value" :key="idx">
              {{ item.name }}
            </div>
          </template>

          <template v-slot:item.study_groups="{ value }">
            <p class="ma-0" v-for="(item, idx) in value" :key="idx">
              {{ item.name }}
            </p>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn small color="primary" @click="openSelectedItemDialog(item)">Invite</v-btn>
          </template>
        </v-data-table>
      </v-card>

      <v-dialog v-model="selected_item_dialog" max-width="800px" @click:outside="closeSelectedItemDialog">
        <v-form @submit="inviteCandidate">
          <v-card v-if="study_group && selected_item && invite">
            <v-toolbar dark dense color="primary">Invite
              <v-spacer/>
              <v-btn icon @click="closeSelectedItemDialog"><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>

            <v-card-text>
              <v-select label="Sub group"
                        v-model="invite.study_sub_group_id"
                        :items="study_group.study_sub_groups"
                        item-value="id"
                        item-text="p1_exam_dates"
                        clearable
              >
                <template v-slot:item="{ item }">
                  <span class="font-weight-bold">{{ item.name }} - </span>
                  <span v-for="(exam_date, idx) in  item.p1_exam_dates" :key="idx" class="mx-1">
                      {{ $moment(exam_date).format('DD/MM/YYYY') }},
                    </span>
                </template>

                <template v-slot:selection="{ item }">
                  <span class="font-weight-bold">{{ item.name }} - </span>
                  <span v-for="(exam_date, idx) in  item.p1_exam_dates" :key="idx" class="mx-1">
                      {{ $moment(exam_date).format('DD/MM/YYYY') }},
                    </span>
                </template>
              </v-select>

              <v-select label="Visitation type"
                        v-model="invite.visitation_type"
                        :items="visitation_type_opts"
                        item-value="value"
                        item-text="text"
              ></v-select>

              <v-switch label="Is Sunday day off?" v-model="invite.sunday_day_off"/>

              <DateField label="Training start"
                         v-model="invite.training_start"

              ></DateField>
              <DateField label="Training end"
                         v-model="invite.training_end"

              ></DateField>

              <v-select label="Package" v-model="invite.package_id" :items="packages" item-text="name" item-value="id"/>

              <v-switch label="Force (without confirm)" v-model="invite.force"></v-switch>
            </v-card-text>
            <v-divider/>
            <v-card-actions class="d-flex justify-center">
              <v-btn class="box-shadow" color="primary" @click="closeSelectedItemDialog">Cancel</v-btn>
              <v-btn class="box-shadow" color="success" type="submit">Invite</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-container>

  </section>
</template>

<script>
import DateField from "@/components/DateField";
export default {
  components: {DateField},
  props: {
    study_group: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    stepper: 1,
    packages: [],
    table_data: {
      headers: [
        { text: 'Name', value: 'full_name'},
        { text: 'Email', value: 'email'},
        { text: 'Profile type', value: 'profile_type'},
        { text: 'Study groups', value: 'study_groups'},
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      items: [],
      search: '',
    },

    candidates: [],
    selected_item: null,
    selected_item_dialog: false,
    visitation_type_opts: [
      {text: 'G1 - workday group', value: 'G1'},
      {text: 'G2 - weekend group', value: 'G2'},
      {text: 'G3 - mix group', value: 'G3'},
    ],
    invite: null



  }),
  created() {
    this.loadCandidates()
    this.loadPackages()
  },
  methods: {
    loadCandidates() {
      this.axios.get(`api/study-groups/${this.$route.params.study_group_id}/candidates`)
        .then(({data}) => this.table_data.items = data.data)
    },
    loadPackages() {
      this.axios.get(`api/packages`).then(({data}) => {this.packages = data.data})
    },
    openSelectedItemDialog(item) {
      this.selected_item = item
      this.selected_item_dialog = true
      this.invite = {
        user_id: item.id,
        visitation_type: 'G1',
        sunday_day_off: false,
        training_start: '',
        training_end: '',
        package_id: null,
        force: false,
      }
    },
    closeSelectedItemDialog() {
      this.selected_item_dialog = false
      this.selected_item = null
      this.invite = null
      this.api_errors = []
    },
    inviteCandidate(e) {
      e.preventDefault()
      this.app_loading = true
      this.axios.post(`api/study-groups/${this.$route.params.study_group_id}/clients`, this.invite)
        .then(() => {
          this.closeSelectedItemDialog()
          this.loadCandidates()
          this.$router.push({name: 'Edit study members', params: this.$route.params})
        })
        .catch(errors => {this.api_errors = errors.response.data.errors})
        .then(() => {this.app_loading = false})
    }
  }
}
</script>